
if (!customElements.get("video-list-with-dialog--card")) {
  let youtubeApiPromise = null;

  function loadYoutubeApi() {
    if (window.YT && window.YT.Player) {
      return Promise.resolve(window.YT);
    }

    if (!youtubeApiPromise) {
      youtubeApiPromise = new Promise((resolve) => {
        const previousReady = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (typeof previousReady === "function") {
            previousReady();
          }
          resolve(window.YT);
        };

        if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          document.head.appendChild(tag);
        }
      });
    }

    return youtubeApiPromise;
  }

  class VideoListCard extends HTMLElement {
    static isInitialized = false;
    /** Cancel video initialize */
    cancelInit = false;

    constructor() {
      super();
      this.hasSwiper = false;
      this.videoContainer = null;
      this.swiperDialogPlayer = null;
      this.youtubePlayer = null;
    }

    connectedCallback() {
      this.checkSwiper();
      this.addEventListener("custom-dialog:open", (e) => {
        const dialog = e.detail.el;
        this.restoreEmbedMedia(dialog);
        this.videoElement = dialog.querySelector("[data-plyr-video]");
        if (this.hasSwiper) {
          if (!this.videoElement) return;
          this.togglePlayerPosistion(true);
          this.videoElement = this.swiperDialogPlayer.querySelector("[data-plyr-video]");
          this.initVideo();
          this.videoPlayer = this.swiperDialogPlayer.querySelector("[data-plyr-video]");
          this.videoPlayer.play();
        } else {
          if (!this.videoElement) return;
          if (this.isYoutubePlaylist()) {
            this.initYoutubePlaylist();
          } else if (this.player) {
            this.play();
          } else {
            this.initVideo();
          }
        }
      });
      window.addEventListener("custom-dialog:close", (e) => {
        const dialog = e.detail && e.detail.el ? e.detail.el : e.target;
        this.stopEmbedMedia(dialog);
        this.stop();
      });
    }

    isYoutubePlaylist() {
      return (
        this.videoElement &&
        this.videoElement.dataset.videoType === "youtube" &&
        !!this.videoElement.dataset.youtubePlaylistId
      );
    }

    checkSwiper() {
      if (this.hasAttribute('data-swiper') && this.getAttribute('data-swiper') === 'true') {
        this.hasSwiper = true;
        this.videoContainer = this.closest('.video-list-swiper');
        this.swiperDialogPlayer = this.videoContainer.querySelector('.video-list-swiper-player-container');
      }
    }

    togglePlayerPosistion(status) {
      if (this.hasSwiper && this.videoContainer) {
        if (status) {
          const playerDialog = this.querySelector('.custom-dialog');

          if (playerDialog && this.swiperDialogPlayer) {
            const clonedPlayerDialog = playerDialog.cloneNode(true);

            this.swiperDialogPlayer.innerHTML = '';

            this.swiperDialogPlayer.appendChild(clonedPlayerDialog);
            clonedPlayerDialog.setAttribute('open', true);

          }
        } else {
          this.swiperDialogPlayer.innerHTML = '';
        }
      }
    }

    play() {
      this.cancelInit = false;
      if (this.youtubePlayer && typeof this.youtubePlayer.playVideo === "function") {
        this.youtubePlayer.playVideo();
        return;
      }
      if (this.player && typeof this.player.play === 'function') {
        this.player.play();
      }
    }

    pause() {
      this.cancelInit = false;
      if (this.youtubePlayer && typeof this.youtubePlayer.pauseVideo === "function") {
        this.youtubePlayer.pauseVideo();
        return;
      }
      if (this.player && typeof this.player.pause === 'function') {
        this.player.pause();
      }
    }

    stop() {
      this.cancelInit = true;
      if (this.youtubePlayer && typeof this.youtubePlayer.stopVideo === "function") {
        this.youtubePlayer.stopVideo();
      }
      if (this.player && typeof this.player.stop === 'function') {
        this.player.stop();
      }
      this.destroyYoutubePlayer();
    }

    distory() {
      this.cancelInit = true;
      this.destroyYoutubePlayer();
      if (this.player && typeof this.player.destroy === 'function') {
        this.player.destroy();
      }
    }

    destroyYoutubePlayer() {
      if (!this.youtubePlayer) return;
      try {
        this.youtubePlayer.destroy();
      } catch (error) {
        /* player may already be destroyed */
      }
      this.youtubePlayer = null;
    }

    stopEmbedMedia(dialog) {
      if (!dialog) return;
      const iframes = dialog.querySelectorAll('.video-list-with-dialog__embed-html iframe');
      iframes.forEach((iframe) => {
        if (!iframe.dataset.originalSrc) {
          iframe.dataset.originalSrc = iframe.getAttribute('src') || '';
        }
        iframe.setAttribute('src', 'about:blank');
      });
    }

    restoreEmbedMedia(dialog) {
      if (!dialog) return;
      const iframes = dialog.querySelectorAll('.video-list-with-dialog__embed-html iframe');
      iframes.forEach((iframe) => {
        const originalSrc = iframe.dataset.originalSrc;
        if (originalSrc) {
          iframe.setAttribute('src', originalSrc);
        }
      });
    }

    initYoutubePlaylist() {
      this.stoped = false;
      this.cancelInit = false;
      this.destroyYoutubePlayer();

      const playlistId = this.videoElement.dataset.youtubePlaylistId;
      const videoId = this.videoElement.dataset.plyrEmbedId;
      const target = this.videoElement;

      if (!playlistId || !target) return;

      if (!target.id) {
        target.id = `youtube-playlist-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      }

      loadYoutubeApi().then((YT) => {
        if (this.cancelInit) return;

        const playerVars = {
          autoplay: 1,
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          listType: "playlist",
          list: playlistId,
        };

        const playerConfig = {
          height: "100%",
          width: "100%",
          playerVars,
          events: {
            onReady: (event) => {
              if (this.cancelInit) {
                event.target.stopVideo();
                return;
              }
              event.target.playVideo();
            },
            onStateChange: (event) => {
              if (event.data === YT.PlayerState.ENDED) {
                event.target.nextVideo();
              }
            },
          },
        };

        if (videoId) {
          playerConfig.videoId = videoId;
        }

        this.youtubePlayer = new YT.Player(target.id, playerConfig);
      });
    }

    initVideo() {
      if (this.isYoutubePlaylist()) {
        this.initYoutubePlaylist();
        return;
      }

      this.stoped = false;
      const player = new Plyr(this.videoElement, {
        autoplay: true,
        resetOnEnd: false,
        muted: false,
        loop: {
          active: false,
        },
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'duration',
          'mute',
          'volume',
          'fullscreen',
        ],
        tooltips: {
          controls: false,
          seek: false,
        },
        youtube: {
          loop: 0,
          title: false,
          showinfo: 0,
          rel: 0,
        },
        quality: { default: 1080, options: [4320, 2880, 2160, 1440, 1080, 720] },
      });
      this.player = player;
      player.on('ready', () => {
        if (!this.cancelInit) {
          player.play();
        } else {
          player.stop();
        }
      });
    }
  }
  customElements.define('video-list-with-dialog--card', VideoListCard);
}
